import React from 'react'
import './contact.css'

function Contact() {
  return (
    <section id='contact'> Contact </section>
  )
}

export default Contact